import { useQuery } from 'react-query';
import { apiService } from '@/src/services/api-service';
import { createBeyondRewardsEndpoint } from '../constants/endpoints';
import { useAccountContext } from '@ovotech/ui-tools';

export enum RewardProductId {
  solarReward = 'c2cc80ef-9385-4a6c-80e2-5a19305ce8a7',
  evReward = 'cadc6d87-8c8d-4797-a7ea-05aa43e91799',
  heatReward = '5d1370a0-097c-4606-94bc-bf930f680574',
}

export enum BoltonStatus {
  ACTIVE = 'ACTIVE',
  REDEEMED = 'REDEEMED',
  CANCELLED = 'CANCELLED',
}

export type AccountBolton = {
  currentLevel: number;
  maxLevel: number;
  unitLabel: string;
  productId: RewardProductId;
  status: BoltonStatus;
  id: string;
  redeemedLabel?: string;
};

export const useRewardsQuery = () => {
  const { accountId } = useAccountContext();

  return useQuery(
    ['home-rewards', accountId],
    () =>
      apiService.get<AccountBolton[]>({
        url: createBeyondRewardsEndpoint(accountId as string),
      }),
    {
      enabled: !!accountId,
    },
  );
};
